import * as signalR from '@microsoft/signalr';
import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { TabConst } from '../../tab-consts';
//import { tabConst } from 'src/app/@theme/const';

@Injectable({
  providedIn: 'root'
})
export class SignalrManagerService {
  private hubConnection: signalR.HubConnection;
  private notificationSubject = new Subject<{ title: string, message: string }>();

  public notification$: Observable<{ title: string, message: string }> = this.notificationSubject.asObservable();

  constructor() {
    const isLocal = window.location.hostname === 'localhost';
    const token = sessionStorage.getItem('access_token');

    this.hubConnection = new signalR.HubConnectionBuilder()
      .withUrl(environment.SignalrHubsUrl, {
         // ...(isLocal ? { transport: signalR.HttpTransportType.LongPolling } : {}),
       //good transport: isLocal ? signalR.HttpTransportType.LongPolling : signalR.HttpTransportType.WebSockets,
       //transport: signalR.HttpTransportType.WebSockets | signalR.HttpTransportType.ServerSentEvents | signalR.HttpTransportType.LongPolling, 
       transport:signalR.HttpTransportType.LongPolling,
      accessTokenFactory: () => token ?? ''
      })
      .withAutomaticReconnect()
      .build();

    this.registerReceiveNotification();
  }
  private registerReceiveNotification(): void {
    this.hubConnection.on(TabConst.RECEIVE_NOTIFICATION, (data: { title: string, message: string }) => {
      this.notificationSubject.next(data); 
    });
  }
  

  public start(): void {
    this.hubConnection
      .start()
      .then(() => {
      })
      .catch(err => {
        if (err?.transport) {
        }
      });
  }
}
